export default {
    accept_payments_for_nonclosed_visit: "Allow accepting payment if the visit is not closed",
    accountingmonth: "Accounting month",
    accrual: "Accrual",
    accruals: "Accruals",
    accrued: "Accrued",
    AQSI_account: "AQSI account",
    balance_end: "Balance end",
    balance_start: "Balance start",
    bonus_movement: "Bonus movement",
    cash_movements: "Cash movements",
    cash_received: "Cash received",
    closed: "Closed",
    communal: "Utility bills",
    deduct_materials_from_doctor_salary: "Deduct materials from doctors' salary",
    deduction: "Deduction",
    deposit_account: "Deposit account",
    deposit_accounts: "Deposit accounts",
    deposit_balance: "Deposit balance",
    deposit_balance_end: "Deposit balance end",
    deposit_balance_start: "Deposit balance start",
    deposit_movement: "Deposit movement",
    employee: "Employee",
    employee_id: "Employee Id",
    expense: "Expense",
    first_payment: "First payment",
    fiscal_cashdesk: "Fiscal сashdesk",
    for_payment_scan_this_qr_in_kyrgyz_bank: "To pay, scan this QR code and pay with any bank in Kyrgyzstan",
    for_payment_scan_this_qr_in_obank_application: "To pay, scan this QR in the OBank application",
    income: "Income",
    left_to_pay: "Left to pay",
    left_to_pay2: "Left to pay",
    manual_adjustments: "Manual adjustments",
    materials_cost: "Cost of materials",
    materials_expense: "Expendable material",
    open: "Open",
    opened: "Opened",
    other_expense: "Other expenses",
    other_income: "Other income",
    pay_out: "Pay out",
    payment_comment: "Payment comment",
    payment_completed_successfully: "Payment completed successfully",
    payment_sum: "Amount to be paid",
    profit: "Income",
    recalculate: "Recalculate",
    refund_to_patient: "Refund to patient",
    rent: "Rent",
    salaries: "Wages",
    unclosed: "Unclosed",
    upselling: "Upselling"
}
